import type { QueryClient } from '@tanstack/react-query';
import type { ServicesApiListAssetsResponse } from '@/services/api/services-api';
import { parseAsset, assetKeys, type Asset } from './entity';

/**
 * Cluster propagation for asset list responses.
 *
 * The list endpoint returns `{ assets, parents, meta }`. `parents` is
 * the breadcrumb chain from the current folder to root — these are also
 * assets (folders), so we populate them into the detail cache alongside
 * the page results.
 */

export interface ParsedAssetsListResponse {
  assets: readonly Asset[];
  parents: readonly Asset[];
  meta: ServicesApiListAssetsResponse['meta'];
}

export function parseAssetsListResponse(raw: ServicesApiListAssetsResponse): ParsedAssetsListResponse {
  return {
    assets: raw.assets.map(parseAsset),
    parents: raw.parents.map(parseAsset),
    meta: raw.meta,
  };
}

export function populateAssetsList(qc: QueryClient, workspaceId: number, response: ParsedAssetsListResponse): void {
  for (const a of response.assets) qc.setQueryData(assetKeys.detail(workspaceId, a.id), a);
  for (const p of response.parents) qc.setQueryData(assetKeys.detail(workspaceId, p.id), p);
}
